import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { ButtonAnchor, ButtonLink } from '../ui/Button';
import { SearchBar } from '../SearchBar';
import { PromoCarousel } from './PromoCarousel';
import { HERO_IMAGE } from '../../data/vehicles';
import { VCARS_BANNER } from '../../data/brand';
import { GENERAL_WA_MESSAGE, whatsappLink } from '../../utils/vehicles';
const stats = [{
  value: '+300',
  label: 'operaciones cerradas'
}, {
  value: '+500',
  label: 'clientes asesorados'
}, {
  value: '12 HS',
  label: 'promedio de respuesta'
}];
const easeOut = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <>
      {/* Presentación de marca: lo primero que ve el visitante. */}
      <motion.section aria-label="VCARS" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 0.4,
      ease: easeOut
    }} className="relative isolate w-full overflow-hidden bg-black" data-id="element-291" data-mp="3ryrt1aknxuwn">
        <motion.img src={VCARS_BANNER} alt="VCARS — usados seleccionados y 0KM" initial={{
        scale: 1.04
      }} animate={{
        scale: 1
      }} transition={{
        duration: 0.9,
        ease: easeOut
      }} className="h-auto w-full object-cover" data-id="element-292" data-mp="1mw2v3ee2go78" />
        <div className="pointer-events-none absolute inset-x-0 bottom-0 h-20 md:h-32" aria-hidden="true" style={{
        background: 'linear-gradient(to top, #05070c 10%, rgba(5,7,12,0))'
      }} data-id="element-293" data-mp="1hwzss1ph0w2y" />
      </motion.section>

      <section className="relative isolate overflow-hidden" data-id="element-294" data-mp="2anzych3ga7wq">
        <img src={HERO_IMAGE} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-60" data-id="element-295" data-mp="1vw952qak361n" />
        <div className="absolute inset-0 bg-ink/75" aria-hidden="true" data-id="element-296" data-mp="2ol6avtxkzadi" />
        <div className="absolute inset-x-0 bottom-0 h-40 bg-ink/90" aria-hidden="true" style={{
        maskImage: 'linear-gradient(to top, black, transparent)',
        WebkitMaskImage: 'linear-gradient(to top, black, transparent)'
      }} data-id="element-297" data-mp="2tcelgtand1s9" />

        <div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-12 md:px-8 md:pb-24 md:pt-20" data-id="element-298" data-mp="2y7hdn9vom016">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          delay: 0.1,
          ease: easeOut
        }} className="max-w-3xl" data-id="element-299" data-mp="2p8m69ugwijwa">
            <p className="inline-flex items-center gap-2 rounded-full border border-neon/40 bg-neon/10 px-3 py-1.5 text-[12.5px] font-semibold text-neon-soft" data-id="element-300" data-mp="2fikgmy8wgtf9">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-301" data-mp="2ahd7ovv0to70" />
              Usados seleccionados y oportunidades reales
            </p>
            <h1 className="mt-5 text-[38px] font-black leading-[1.02] tracking-tight text-white sm:text-5xl lg:text-[64px]" data-id="element-302" data-mp="21jb3k7fzqffi">
              Encontrá tu próximo auto con{' '}
              <span className="text-neon" data-id="element-303" data-mp="c260f9kskus4">VCARS</span>
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-white/75 md:text-lg" data-id="element-304" data-mp="c40a1rqm50gw">
              Usados seleccionados, 0KM, financiación, permutas y venta particular
              gestionada en un solo lugar.
            </p>

            <div className="mt-7 flex flex-wrap gap-3" data-id="element-305" data-mp="q272utgpga9p">
              <ButtonLink to="/catalogo" size="lg" data-id="element-306" data-mp="pzkvatttdurh">
                Ver catálogo
              </ButtonLink>
              <ButtonLink to="/vender-mi-auto" variant="outline" size="lg" data-id="element-307" data-mp="3pepofncv3tiz">
                Quiero vender mi auto
              </ButtonLink>
              <ButtonAnchor href={whatsappLink(GENERAL_WA_MESSAGE)} variant="whatsapp" size="lg" data-id="element-308" data-mp="2buksprqwx5e">
                <MessageCircleIcon className="h-4 w-4" aria-hidden="true" data-id="element-309" data-mp="74nrhj6ryfk4" />
                Hablar con un vendedor
              </ButtonAnchor>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.28,
          delay: 0.16,
          ease: easeOut
        }} className="mt-16 max-w-4xl md:mt-24" data-id="element-310" data-mp="3aq34178dobkw">
            <SearchBar size="lg" data-id="element-311" data-mp="31dma2mrs7e75" />
          </motion.div>

          <div className="mt-10 md:mt-12" data-id="element-312" data-mp="31f73ua69ut3y">
            <PromoCarousel data-id="element-313" data-mp="2wlufm15i8obq" />
          </div>

          <dl className="mt-12 grid max-w-3xl grid-cols-3 divide-x divide-neon/25 overflow-hidden rounded-2xl border border-neon/45 bg-ink/70 backdrop-blur-md md:mt-16" style={{
          boxShadow: '0 0 0 1px rgba(31,123,255,0.18), 0 0 28px -6px rgba(31,123,255,0.55), inset 0 0 24px -12px rgba(31,123,255,0.9)'
        }} data-id="element-314" data-mp="2wl2vbmhcyd0r">
            {stats.map(s => <div key={s.label} className="px-4 py-5 text-center md:px-6 md:py-6" data-id="element-315" data-mp="3fb13e2l5o64e">
                <dt className="sr-only" data-id="element-316" data-mp="1py7arcc3oa8v">{s.label}</dt>
                <dd data-id="element-317" data-mp="1kzmdnls5a6on">
                  <span className="block text-2xl font-black tracking-tight text-neon-soft md:text-4xl" style={{
                textShadow: '0 0 18px rgba(31,123,255,0.75)'
              }} data-id="element-318" data-mp="1l05sgtmi0eyg">
                    {s.value}
                  </span>
                  <span className="mt-1.5 block text-[11.5px] font-semibold uppercase leading-snug tracking-wide text-mist md:text-[12.5px]" data-id="element-319" data-mp="3mx69jgtrwngb">
                    {s.label}
                  </span>
                </dd>
              </div>)}
          </dl>
        </div>
      </section>
    </>;
}